export default __webpack_public_path__ + "static/media/Home_thmb_Sanada.863a4eae.png";